import type { ReactNode } from 'react';
import { ProductCarousel as UiProductCarousel } from '@/components/ui';
import { cn } from '@/lib/utils';
import { homeProductCarouselStyles } from './ProductCarousel.styles';

export type HomeProductCarouselProps = {
  title?: ReactNode;
  children: ReactNode;
  spaceBetween?: number;
  className?: string;
};

/** Thin home wrapper around ui/ProductCarousel (Swiper slidesPerView auto). */
export function ProductCarousel({
  title,
  children,
  spaceBetween,
  className,
}: HomeProductCarouselProps): JSX.Element {
  return (
    <div className={cn(homeProductCarouselStyles.root, className)}>
      <UiProductCarousel title={title} spaceBetween={spaceBetween}>
        {children}
      </UiProductCarousel>
    </div>
  );
}
